import { FC } from 'react';
import styles from './index.module.less';
import ProductPrice from '@base/snippets/ProductPriceV2';
import { IVariant } from 'base/interfaces/product';

type IProdPriceProps = {
    shownVariant: IVariant;
};

export const ProdPrice: FC<IProdPriceProps> = props => {
    const { shownVariant } = props;
    return (
        <ProductPrice
            className={styles.prices}
            product={shownVariant}
            direction="horizontal"
        />
    )
};
